import { render, staticRenderFns } from "./MeasurementData.vue?vue&type=template&id=62853fa4&"
import script from "./MeasurementData.vue?vue&type=script&lang=js&"
export * from "./MeasurementData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports